import { render } from "./DepartureDetail.vue?vue&type=template&id=4570c7a0&scoped=true"
import script from "./DepartureDetail.vue?vue&type=script&lang=js"
export * from "./DepartureDetail.vue?vue&type=script&lang=js"

import "./DepartureDetail.vue?vue&type=style&index=0&id=4570c7a0&scoped=true&lang=css"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4570c7a0"]])

export default __exports__